import actions from '../../actionTypes';

export default (area, save, ignoreFile) => {
  return {
    type: actions.SET_CURRENT_AREA,
    area,
    save,
    ignoreFile // file required for map view only
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/setCurrentArea.js